export default "/packs/4cf0d6f41e256bf7adc09ffad10dc12f.svg";